import type { QuickLoginRow } from "@observe-tech/utils";
import { useCallback, useEffect, useState } from "react";
import {
  listQuickLogins,
  quickLoginAvailable,
} from "../../../../shell-handle/quickLoginSession";

const LOAD_TIMEOUT_MS = 1500;

type SavedAccounts = QuickLoginRow[] | null | undefined;

export function useSavedAccounts(capable: boolean) {
  const [rows, setRows] = useState<SavedAccounts>(capable ? undefined : null);

  const refresh = useCallback(async () => {
    const next = await listQuickLogins();
    setRows(next);
    return next;
  }, []);

  useEffect(() => {
    if (!capable) return;
    const settle = (next: QuickLoginRow[] | null) =>
      setRows((current) => (current === undefined ? next : current));
    const timer = setTimeout(() => settle(null), LOAD_TIMEOUT_MS);
    void quickLoginAvailable()
      .then((ok) => (ok ? listQuickLogins() : null))
      .catch(() => null)
      .then(settle)
      .finally(() => clearTimeout(timer));
    return () => clearTimeout(timer);
  }, [capable]);

  return { rows, refresh };
}
